import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const riskForm: Form<Client> = {
  key: 'riskData',
  title: 'Gefährdung',
  fields: [
    {
      key: 'riskAssessment',
      label: 'Gefährdungseinschätzung',
      fieldTypes: 'select',
      xsWidth: 6,
      options: [
        {
          label: 'ungeklärt',
          value: 'unknown',
        },
        {
          label: 'gering',
          value: 'low',
        },
        {
          label: 'mittel',
          value: 'medium',
        },
        {
          label: 'hoch',
          value: 'high',
        },
      ],
    },
    {
      key: '',
      label: 'Gefährdungseinschätzung',
      fieldTypes: 'valueIndicator',
      itemFieldKey: 'riskAssessment',
      xsWidth: 6,
    },
    {
      key: 'potentialThreat',
      label: 'Gefährder',
      fieldTypes: 'text',
    },
    {
      key: 'potentialThreatBirthday',
      label: 'Gefährder Geburtstag',
      fieldTypes: 'date',
    },
    {
      key: 'riskNotice',
      label: 'Informationen',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
    {
      key: 'riskSafetyMeasures',
      label: 'Sicherheitsmaßnahmen',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
    {
      key: 'riskPoliceMeasures',
      label: 'Polizeiliche Maßnahmen',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default riskForm;
